<template>
  <div class="wrap">
    <div class="header-wrap">
      <div class="header">
        <img
          src="@/assets/return.png"
          class="return-img"
          @click="$router.back()"
          alt=""
        />
        <p class="header-title">我的评论</p>
        <button
          type="button"
          class="header-btn"
          @click="swipeCellList.openOrCloseEdit()"
        >
          {{ swipeCellList && swipeCellList.edit ? "取消" : "管理" }}
        </button>
      </div>
    </div>

    <swipe-cell-list ref="swipeCellList" :option="swipeCellOption">
      <template #item="{ item }">
        <div class="my-collection-item-column">
          <div class="like-me-top">
            <div class="like-me-top-top">
              <img
                :src="item.headimg"
                class="like-me-top-top-img"
                v-if="item.headimg"
                alt=""
              />
              <img
                src="@/assets/avatar.png"
                class="like-me-top-top-img"
                v-else
                alt=""
              />
              <div class="reply-between-box">
                <div class="like-me-top-top-sidebar">
                  <p class="like-me-top-top-name">
                    <text-hide
                      :val="item.user_name || '匿名用户'"
                      :max-size="10"
                      :hide-btn="true"
                    />
                  </p>
                  <p class="like-me-top-top-time">{{ item.create_at }}</p>
                </div>
              </div>
            </div>
            <p class="like-me-top-bottom">
              <text-hide-by-line :val="item.content" />
            </p>
          </div>
          <div class="my-collection-module" @click="toDetail(item)">
            <div class="my-collection-module-top">
              <!-- 失效时候显示 -->
              <div
                class="my-collection-module-top-img-box"
                v-if="item.is_normal === 0"
              >
                <img
                  src="@/assets/icon-175.png"
                  class="my-collection-module-top-img"
                  alt=""
                />
              </div>
              <!-- 正常 -->
              <div class="my-collection-module-top-img-box" v-else>
                <img
                  :src="item.cover"
                  class="my-collection-module-top-img"
                  alt=""
                />
                <span class="my-collection-module-top-time">新闻</span>
              </div>
              <div class="my-collection-module-top-sidebar">
                <div class="my-collection-module-top-sidebar-top">
                  <p class="my-collection-module-top-sidebar-title">
                    <text-highlight
                      :val="item.title"
                      :highlight-key="swipeCellList.searchKeyword"
                    />
                  </p>
                </div>
                <div class="my-collection-module-top-sidebar-bottom">
                  <p class="my-collection-module-top-sidebar-row1">
                    <img
                      :src="item.app_logo"
                      class="like-me-top-top-img"
                      v-if="item.app_logo"
                      alt=""
                    />
                    <img
                      src="@/assets/avatar.png"
                      class="like-me-top-top-img"
                      v-else
                      alt=""
                    />
                    <span>{{ item.app_name || "匿名用户" }}</span>
                  </p>
                  <p class="my-collection-module-top-sidebar-row2">
                    <img src="@/assets/icon-83.png" alt="" />
                    <span>{{ item.read_num }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </swipe-cell-list>

    <!-- 删除弹窗 -->
    <van-overlay
      :show="deletePopup"
      @click="deletePopup = false"
      z-index="99999"
    >
      <div class="window">
        <span class="window-text">确定要删除该信息</span>
        <div class="window-btn-box">
          <button type="button" class="cancel" @click="deletePopup = false">
            取消
          </button>
          <button type="button" class="confirm" @click="batchesDel(checkIds)">
            确定
          </button>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { PressService } from "@/common/service";
import { Toast } from "vant";
import SwipeCellList from "@/components/swipe-cell-list.vue";
import TextHide from "@/components/text-hide.vue";
import TextHideByLine from "@/components/text-hide-by-line.vue";
import TextHighlight from "@/components/text-highlight.vue";

export default {
  components: {
    TextHideByLine,
    TextHide,
    SwipeCellList,
    TextHighlight
  },
  data() {
    return {
      // 删除弹窗
      deletePopup: false,

      checkIds: "",

      swipeCellOption: {
        showSearch: true,
        searchKey: "title",
        listApi: (params) => PressService.getMyPressComment(params),
        itemButtons: [
          {
            text: "删除",
            bgColor: "#FFAE18",
            click: (item) => {
              this.checkIds = item.id;
              this.deletePopup = true;
            },
          },
        ],
        bottomButtons: [
          {
            text: "删除",
            bgColor: "#FFAE18",
            click: (items = []) => {
              if (items.length === 0) {
                return Toast("请至少选择一个");
              }
              this.checkIds = items.map((item) => item.id).join(",");
              this.deletePopup = true;
            },
          },
        ],
      },
      swipeCellList: null,
    };
  },
  mounted() {
    this.swipeCellList = this.$refs.swipeCellList;
  },
  methods: {
    toDetail(item) {
      if (item.is_normal === 0) return Toast("已下架");
      this.$router.push(`/news-details?press_id=${item.press_id}`);
    },

    // 删除
    batchesDel(ids) {
      return PressService.batchesDel({
        id: ids,
        type: 2,
      }).then(({ msg }) => {
        Toast(msg);
        this.swipeCellList.resetList();
        this.swipeCellList.openOrCloseEdit(true);
      });
    },
  },
};
</script>

<style scoped>
/* 头部样式 */
.header-wrap {
  width: 100%;
  height: 44px;
  /* 	height: 102px; */
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 500;
  background-color: #ffffff;
}

.header-wrap-tab-list-none {
  height: 80px;
  padding-bottom: 10px;
}

.header {
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  z-index: 999;
  /* padding: 0 15px; */
  position: relative;
  box-sizing: border-box;
}

.return-img {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translate(0, -50%);
  width: 20px;
  z-index: 99999;
}

.header-title {
  width: 100%;
  text-align: center;
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  position: relative;
}

.full-mark-read {
  position: absolute;
  right: 73px;
  top: 50%;
  transform: translate(0, -50%);
  color: #2a63f3;
  font-size: 11px;
  padding: 0 6px;
  border-radius: 50px;
  background-color: #f2f6ff;
  height: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
}

.full-mark-read > img {
  width: 14px;
  margin-right: 2px;
}

.header-btn {
  color: #222222;
  font-size: 14px;
  position: absolute;
  padding: 0 12px;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
}

.search-box {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  box-sizing: border-box;
}

.search-bar {
  flex: 1;
  height: 36px;
  background-color: #ffffff;
  border-radius: 100px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
}

.search-icon {
  width: 16px;
  margin-right: 8px;
}

.search-input {
  flex: 1;
  font-size: 14px;
}

.search-input::placeholder {
  color: #888888;
}

.tab-list > li {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  color: #555555;
  position: relative;
}

.tab-list > li.active {
  font-size: 18px;
  font-weight: bold;
  color: #222222;
}

.tab-list > li.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  background: linear-gradient(90deg, #2a63f3, #81b8ff);
  border-radius: 2px;
  width: 18px;
  height: 4px;
}

.wrap {
  width: 100%;
  height: calc(100vh - 44px);
  display: flex;
  flex-direction: column;
  margin: 44px 0 0;
  box-sizing: border-box;
  background: #f4f4f4;
  overflow-y: auto;
}

.wrap-tab-list-none {
  height: calc(100vh - 90px);
  margin: 90px 0 0;
}

.sub-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px 15px;
  box-sizing: border-box;
  /*height: 100%;*/
  overflow: auto;
}

.sub-list > li {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  margin-bottom: 12px;
  padding: 10px;
  box-sizing: border-box;
  position: relative;
}

.sub-list > li:last-child {
  margin-bottom: 0;
}

.float-box {
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 40px;
  z-index: 499;
}

.float-box > button {
  min-width: 175px;
  height: 44px;
  line-height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2a63f3;
  border-radius: 100px;
  color: #ffffff;
  font-size: 18px;
  font-weight: bold;
}

.module {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px 15px;
  box-sizing: border-box;
}

.time {
  width: 100%;
  color: #7f7f7f;
  font-size: 10px;
  margin-bottom: 12px;
}

.list {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.list > li {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  background-color: #ffffff;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 12px 10px 14px 18px;
  box-sizing: border-box;
  position: relative;
}

.list > li:last-child {
  margin-bottom: 0;
}

.img-box {
  width: 26px;
  height: 30px;
  position: relative;
  margin-right: 16px;
}

.img {
  width: 100%;
  height: 100%;
}

.tag {
  width: 34px;
  height: 14px;
  line-height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg, #ffcd7c, #ffeeba);
  border-radius: 0 7px 0 7px;
  color: #222222;
  font-size: 12px;
  font-weight: bold;
  position: absolute;
  right: 0;
  top: 0;
}

.tag-black {
  width: 34px;
  height: 14px;
  line-height: 14px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 50px;
  color: #ffffff;
  font-size: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 8px;
  bottom: 8px;
}

.item-sidebar {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.item-name {
  width: 100%;
  line-height: 21px;
  color: #222222;
  font-size: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.row {
  width: 100%;
  display: flex;
  align-items: center;
  color: #999999;
  font-size: 12px;
}

.avatar {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-right: 4px;
  object-fit: cover;
}

.row2 {
  width: 100%;
  display: flex;
  align-items: center;
  color: #999999;
  font-size: 12px;
}

.play-icon {
  width: 12px;
  margin-right: 4px;
}

.item-between {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.circle-btn {
  width: 13px;
  height: 13px;
}

.circle-icon {
  width: 13px;
}

.font-1 {
  font-size: 10px;
  color: #888888;
}

.normal-box-small {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  color: #888888;
  padding: 48px 0;
}

.normal-box-small > img {
  width: 195.2px;
  margin-bottom: 38px;
}

.my-collection-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 12px 0;
  box-sizing: border-box;
}

.my-collection-list > li {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 14px;
  padding-bottom: 10px;
  padding-right: 10px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 10px;
  margin-bottom: 10px;
}

.my-circle-box {
  padding-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.my-circle-box > img {
  width: 24px;
  height: 24px;
}

.my-collection-module {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f3f3f3;
  border-radius: 6px;
  padding: 10px;
  box-sizing: border-box;
}

.my-collection-module-top {
  width: 100%;
  display: flex;
  align-items: center;
}

.my-collection-module-top-img-box {
  width: 130px;
  height: 73px;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  margin-right: 10px;
}

.my-collection-module-top-img {
  width: 100%;
  height: 100%;
}

.my-collection-module-top-time {
  background: rgba(0, 0, 0, 0.7);
  height: 12px;
  line-height: 12px;
  display: flex;
  align-items: center;
  padding: 0 2px;
  font-size: 9px;
  color: #ffffff;
  position: absolute;
  right: 7px;
  bottom: 4px;
}

.my-collection-module-top-time-gray {
  background: rgba(0, 0, 0, 0.3);
  height: 12px;
  line-height: 12px;
  display: flex;
  align-items: center;
  padding: 0 2px;
  font-size: 9px;
  color: #ffffff;
  position: absolute;
  right: 7px;
  bottom: 3px;
}

.my-collection-module-top-sidebar {
  flex: 1;
  height: 73px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.my-collection-module-top-sidebar-top {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.my-collection-module-top-sidebar-title {
  width: 100%;
  color: #222222;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.my-collection-module-top-sidebar-sub-title {
  width: 100%;
  color: #222222;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.my-collection-module-top-sidebar-bottom {
  width: 100%;
  display: flex;
  align-items: center;
}

.my-collection-module-top-sidebar-row1 {
  color: #666666;
  font-size: 10px;
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.my-collection-module-top-sidebar-row1 > span {
  max-width: 73px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.my-collection-module-top-sidebar-row1 > img {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 2px;
}

.my-collection-module-top-sidebar-row2 {
  color: #999999;
  font-size: 10px;
  display: flex;
  align-items: center;
}

.my-collection-module-top-sidebar-row2 > span {
  /* 	max-width: 45px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical; */
}

.my-collection-module-top-sidebar-row2 > img {
  width: 12px;
  margin-right: 2px;
}

.my-collection-module-bottom {
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.my-collection-module-bottom-btn {
  display: flex;
  align-items: center;
  color: #333333;
  font-size: 12px;
}

.my-collection-module-bottom-btn.active {
  color: #2a63f3;
}

.my-collection-module-bottom-btn > img {
  width: 16px;
  margin-right: 4px;
}

.footer {
  width: 100%;
  height: 83px;
  box-sizing: border-box;
  padding-top: 8px;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
}

.footer-wrap {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  box-sizing: border-box;
}

.footer-all-btn {
  display: flex;
  align-items: center;
  color: #999999;
  font-size: 14px;
}

.footer-all-btn > img {
  width: 24px;
  margin-right: 4px;
}

.cancel-collection-btn {
  background-color: #ffaf18;
  border-radius: 50px;
  width: 100px;
  height: 40px;
  color: #ffffff;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cancel-collection-btn.blue {
  background-color: #2a63f3;
}

.font-10 {
  color: #666666;
  font-size: 11px;
}

.font-11 {
  color: #ff6700;
  font-size: 11px;
  margin: 0 10px;
}

.header-tab-list {
  width: 100%;
  display: flex;
  align-items: center;
  height: 40px;
  border-top: 1px solid #f4f4f4;
  box-sizing: border-box;
  background-color: #ffffff;
}

.header-tab-list > li {
  flex: 1;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #222222;
  font-size: 15px;
  position: relative;
}

.header-tab-list > li.active {
  color: #2a63f3;
  font-weight: bold;
}

.header-tab-list > li.active::after {
  content: "";
  border-radius: 2px;
  background-color: #2a63f3;
  width: 34px;
  height: 3px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.header-tab-circle {
  color: #ffffff;
  font-size: 10px;
  min-width: 12px;
  height: 12px;
  line-height: 12px;
  padding: 0 2px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 2px;
  background-color: #ff5143;
  border-radius: 50%;
}

.subscribe-messages-module {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.subscribe-messages-head-between {
  width: 100%;
  height: 45px;
  border-bottom: 1px solid #f4f4f4;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subscribe-messages-head-left {
  display: flex;
  align-items: center;
}

.font-12 {
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  color: #222222;
  font-size: 15px;
  font-weight: bold;
}

.font-13 {
  margin-left: 4px;
  border-radius: 50px;
  background-color: #ff5143;
  padding: 0 5px;
  height: 16px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
  font-size: 10px;
}

.subscribe-messages-head-right {
  color: #999999;
  font-size: 12px;
  margin-left: 6px;
}

.subscribe-messages-bottom {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 9px 0 13px;
}

.subscribe-messages-bottom-title {
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  color: #222222;
  font-size: 13px;
}

.subscribe-messages-bottom-btn-box {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.subscribe-messages-bottom-btn {
  color: #222222;
  font-size: 11px;
  padding: 0 11px;
  height: 24px;
  line-height: 24px;
  border: 1px solid #979797;
  box-sizing: border-box;
  border-radius: 50px;
  width: fit-content;
  background-color: #ffffff;
  display: flex;
  align-items: center;
}

.next-unread {
  width: 108px;
  height: 30px;
  border-radius: 15px 0 0 15px;
  border: 1px solid #2a63f3;
  background-color: #ffffff;
  position: fixed;
  right: 0;
  bottom: 68px;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2a63f3;
  font-size: 12px;
}

.next-unread > img {
  width: 12px;
  margin-right: 2px;
}

.like-me-top {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}

.like-me-top-top {
  width: 100%;
  display: flex;
  align-items: center;
}

.like-me-top-top-img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin-right: 8px;
}

.like-me-top-top-sidebar {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.like-me-top-top-name {
  width: 100%;
  color: #222222;
  font-size: 14px;
}

.like-me-top-top-time {
  width: 100%;
  color: #999999;
  font-size: 10px;
}

.like-me-top-bottom {
  width: 100%;
  color: #222222;
  font-size: 14px;
  margin-top: 10px;
}

.comment-on {
  width: 100%;
  color: #666666;
  font-size: 14px;
  margin-bottom: 10px;
}

.full-text-btn {
  color: #2a63f3;
  font-size: 14px;
}

.reply-between-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reply-btn-blue {
  color: #2a63f3;
  font-size: 11px;
  width: 50px;
  height: 24px;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #2a63f3;
  border-radius: 40px;
  background-color: #ffffff;
}
.my-collection-item-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.window {
  width: calc(100% - 54px);
  height: 180px;
  border-radius: 12px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 38px 25px 32px;
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.window-text {
  color: #222222;
  font-size: 18px;
}

.window-btn-box {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 43px;
}

.window-btn-box > button {
  flex: 1;
  height: 42px;
  font-size: 17px;
  margin-right: 27px;
  border-radius: 50px;
}

.window-btn-box > button:last-child {
  margin-right: 0;
}

.window-btn-box > button.cancel {
  background-color: #f4f4f4;
  color: #333333;
}

.window-btn-box > button.confirm {
  background-color: #2a63f3;
  color: #ffffff;
}
</style>
